<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/customers">Customers</Link></li>
        <li class="breadcrumb-item"><Link :href="`/customers/${customers.id}/view`">{{ form.first_name }} {{ form.middle_name }} {{ form.last_name }}</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit</li>
      </ol>
    </nav>

    <h1>
      {{ form.first_name }} {{ form.last_name }}
    </h1>

    <trashed-message v-if="customers.deleted_at" class="mb-6" @restore="restore"> This customer has been deleted. </trashed-message>

    <div class="content-box">
      <form @submit.prevent="update">
        <CustomerForm :form="form" />

        <div class="actions-toolbar d-flex justify-content-between">
          <button v-if="!customers.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Customer</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Customer</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import CustomerForm from './components/CustomerForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    CustomerForm,
    TrashedMessage
  },
  layout: Layout,
  props: {
    customers: Object,
    passengers: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        company: this.customers.company,
        title: this.customers.title,
        first_name: this.customers.first_name,
        middle_name: this.customers.middle_name,
        last_name: this.customers.last_name,
        address_1: this.customers.address_1,
        address_2: this.customers.address_2,
        postal_code: this.customers.postal_code,
        city: this.customers.city,
        country: this.customers.country,
        state: this.customers.state,
        email: this.customers.email,
        website: this.customers.website,
        phone: this.customers.phone,
        cell_phone: this.customers.cell_phone,
        passengers: this.passengers ? this.passengers : [],
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/customers/${this.customers.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this customer?')) {
        this.$inertia.delete(`/customers/${this.customers.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this customer?')) {
        this.$inertia.put(`/customers/${this.customers.id}/restore`)
      }
    },
    addPassenger() {
      this.form.passengers.push({
        sex: "",
        given_names: "",
        surname: "",
        dob: "",
        nationality: "",
        passport_number: "",
        passport_issue: "",
        passport_valid: "",
      });
    },
    removePassenger(index, passenger) {
      this.form.passengers.splice(index, 1);

      this.$inertia.delete(`/passengers/${passenger.id}`)
    },
  },
}
</script>

<style lang="scss">
.passenger-item {
  padding: 1rem;
  margin-bottom: 1rem;
  background: $gray-200;
}
</style>
